import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { useHiringQualificationRanking } from "@src/appV2/redesign/Placements/api/useHiringQualificationRanking";

import { type PlacementData } from "../../../types/placement";
import { formatWorkerTypesLabel } from "../../../utils/formatWorkerTypesLabel";
import { PlacementCardPayV2 } from "./PlacementCardPayV2";

interface PlacementCardFooterProps {
  payRange: PlacementData["payRange"];
  loadingPayData: boolean;
  minMaxPayEstimate:
    | {
        min: number;
        max: number;
      }
    | undefined;
  onInView?: () => void;
  workerTypes: PlacementData["workerTypes"];
  qualifications: Set<string>;
  blurPlacement: boolean;
}

export function PlacementCardFooter(props: PlacementCardFooterProps) {
  const {
    payRange,
    loadingPayData,
    qualifications,
    blurPlacement,
    minMaxPayEstimate,
    onInView,
    workerTypes,
  } = props;

  const { sortQualificationsByRanking } = useHiringQualificationRanking();

  const filteredWorkerTypes = (workerTypes ?? []).filter(
    (workerType) => qualifications?.size === 0 || qualifications.has(workerType)
  );

  const workerTypesToDisplay =
    filteredWorkerTypes.length > 0 ? filteredWorkerTypes : workerTypes ?? [];

  const sortedWorkerTypes = sortQualificationsByRanking(workerTypesToDisplay);
  const workerTypesLabel = formatWorkerTypesLabel(sortedWorkerTypes);

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
      <Stack gap={1} direction="row" alignItems="center" flexWrap="wrap" flex={1} overflow="hidden">
        {isDefined(workerTypesLabel) && (
          <Text
            variant="body2"
            sx={{
              color: (theme) => theme.palette.text.secondary,
              filter: blurPlacement ? "blur(8px)" : undefined,
            }}
          >
            {workerTypesLabel}
          </Text>
        )}
      </Stack>
      <Stack
        spacing={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        minWidth={150}
      >
        <PlacementCardPayV2
          payRange={payRange}
          loadingPayData={loadingPayData}
          minMaxPayEstimate={minMaxPayEstimate}
          onInView={() => {
            if (isDefined(onInView)) {
              onInView();
            }
          }}
        />
      </Stack>
    </Stack>
  );
}
